import { render, staticRenderFns } from "./sidebar_date_widget.vue?vue&type=template&id=a74875d6"
import script from "./sidebar_date_widget.vue?vue&type=script&lang=js"
export * from "./sidebar_date_widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports